module.exports = __webpack_public_path__ + "static/media/clock.5433ea50.svg";